import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routes } from '../routes';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { useKyc } from '@/features/kyc/hooks';

const freeRoutes = new Set<string>([
  routes.kyc.inProgress,
  routes.kyc.failed,
  routes.kyc.manualAddress,
  routes.kyc.proofOfAddress,
]);

export const KycGuard = () => {
  const location = useLocation();
  const {
    isKycLoading,
    isKycInProgress,
    isKycInvalid,
    isUserActionRequired,
    needsManualAddress,
    needsProofOfAddress,
  } = useKyc(true);

  if (isKycLoading) {
    return <PageLoader />;
  }

  const nextStep = getNextKycStep(
    isKycInProgress,
    isKycInvalid,
    isUserActionRequired,
    needsManualAddress,
    needsProofOfAddress
  );

  const isFreeRoute = freeRoutes.has(location.pathname);

  if (location.pathname !== nextStep && !isFreeRoute) {
    return <Navigate to={nextStep} replace />;
  }

  return <Outlet />;
};

const getNextKycStep = (
  isKycInProgress: boolean,
  isKycInvalid: boolean,
  isUserActionRequired: boolean,
  needsManualAddress: boolean,
  needsProofOfAddress: boolean
) => {
  if (isKycInProgress) {
    return routes.kyc.inProgress;
  }

  if (isUserActionRequired) {
    return routes.kyc.base;
  }

  if (needsManualAddress) {
    return routes.kyc.manualAddress;
  }

  if (needsProofOfAddress) {
    return routes.kyc.proofOfAddress;
  }

  if (isKycInvalid) {
    return routes.kyc.failed;
  }

  return routes.wizard.base;
};
